 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_SERIES_PAGE from '@/components/xhtml/02_Series_Page'
 import XHTML03_COPYRIGHT_PAGE from '@/components/xhtml/03_Copyright_Page'
 import XHTML04_FRONT_MATTER from '@/components/xhtml/04_Front_Matter'
 import XHTML05A_TITLE_PAGE from '@/components/xhtml/05a_Title_page'
 import XHTML05_TABLE_OF_CONTENTS from '@/components/xhtml/05_Table_of_Contents'
 import XHTML06_EDITOR_S_NOTE from '@/components/xhtml/06_Editor_s_Note'
 import XHTML07_HANSEL from '@/components/xhtml/07_Hansel'
 import XHTML08_TRANSLATED_BY_TOSHIYA_KAMEI_GIFT from '@/components/xhtml/08_Translated_by_Toshiya_Kamei_Gift'
 import XHTML09_A_POINT_THAT_FLOWS from '@/components/xhtml/09_A_Point_that_Flows'
 import XHTML10_ON_HAIR_AND_BABIES_AND_THE_GOBLI from '@/components/xhtml/10_On_Hair_and_Babies_and_the_Gobli'
 import XHTML11_URBAN_FAIRY_TALE from '@/components/xhtml/11_Urban_Fairy_Tale'
 import XHTML12_CUSTOMERS_WHO_HAVE_BOUGHT_SLEEPI from '@/components/xhtml/12_Customers_Who_Have_Bought_Sleepi'
 import XHTML13_FIVE_POEMS from '@/components/xhtml/13_Five_Poems'
 import XHTML14_THE_PULLEY from '@/components/xhtml/14_The_Pulley'
 import XHTML15_A_BRIEF_TOUR_OF_STRING_QUARTET_N from '@/components/xhtml/15_A_Brief_Tour_of_String_Quartet_n'
 import XHTML16_TWO_POEMS from '@/components/xhtml/16_Two_Poems'
 import XHTML17_THE_FLOOD from '@/components/xhtml/17_The_Flood'
 import XHTML18_GOD_BLESS_A_GIRL_WHO_THINKS_AHEA from '@/components/xhtml/18_God_Bless_a_Girl_Who_Thinks_Ahea'
 import XHTML19_APPENDIX_TO_THE_ENCYCLOPEDIA from '@/components/xhtml/19_Appendix_to_The_Encyclopedia'
 import XHTML20_OF_POEMS from '@/components/xhtml/20_of_poems'
 import XHTML21_FAMILIAR from '@/components/xhtml/21_Familiar'
 import XHTML22_HOW_TO_MAKE_A_LIST from '@/components/xhtml/22_How_to_Make_a_List'
 import XHTML23_SALAMANDRINE__MY_KID from '@/components/xhtml/23_Salamandrine__My_Kid'
 import XHTML24_O_EMPRESS__WHAT_PRIMAL_SPARK from '@/components/xhtml/24_O_Empress__What_Primal_Spark'
 import XHTML25_ANNABEL_LEE from '@/components/xhtml/25_Annabel_Lee'
 import XHTML26_PRINCELING from '@/components/xhtml/26_Princeling'
 import XHTML27_LETTERS__CRONES_DONT_WORRY_OF from '@/components/xhtml/27_Letters__Crones_Dont_Worry_Of'
 import XHTML28_THE_RED_GOBLIN from '@/components/xhtml/28_The_Red_Goblin'
 import XHTML29_THREE_POEMS_FROM_GOODBYE_FLICKER from '@/components/xhtml/29_Three_Poems_from_Goodbye_Flicker'
 import XHTML30_INEBRIATE_OF_AIR from '@/components/xhtml/30_Inebriate_of_Air'
 import XHTML31_EXCERPTS_FROM_PIRATE_TALK_OR_MER from '@/components/xhtml/31_Excerpts_from_Pirate_Talk_or_Mer'
 import XHTML32_THE_CITY from '@/components/xhtml/32_The_City'
 import XHTML33_THE_KINGDOM_S_GOOD from '@/components/xhtml/33_The_Kingdom_s_Good'
 import XHTML34_UBI_SUNT_QUI_ANTE_NOS_FUERUNT from '@/components/xhtml/34_Ubi_sunt_qui_ante_nos_fuerunt'
 import XHTML35_FUNCTIONS_AND_VARIABLES_AND_OTHE from '@/components/xhtml/35_Functions_and_Variables_and_Othe'
 import XHTML36_CONTRIBUTOR_NOTES from '@/components/xhtml/36_Contributor_Notes'
 import XHTML37_ANNOUNCEMENTS from '@/components/xhtml/37_Announcements'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Table_of_Contents",
 			"name" : "xhtml/05_Table_of_Contents",
 			"component" : XHTML05_TABLE_OF_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_Editor_s_Note",
 			"name" : "xhtml/06_Editor_s_Note",
 			"component" : XHTML06_EDITOR_S_NOTE
 		},
 		{
 			"path" : "/xhtml/07_Hansel",
 			"name" : "xhtml/07_Hansel",
 			"component" : XHTML07_HANSEL
 		},
 		{
 			"path" : "/xhtml/08_Translated_by_Toshiya_Kamei_Gift",
 			"name" : "xhtml/08_Translated_by_Toshiya_Kamei_Gift",
 			"component" : XHTML08_TRANSLATED_BY_TOSHIYA_KAMEI_GIFT
 		},
 		{
 			"path" : "/xhtml/09_A_Point_that_Flows",
 			"name" : "xhtml/09_A_Point_that_Flows",
 			"component" : XHTML09_A_POINT_THAT_FLOWS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js